import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import React, { useRef } from "react";
import { B as Box } from "./Grid-CcQKdsgp.js";
import { B as Button } from "./Button-BduN4i4I.js";
import { F as Flex } from "./Flex-BqkSIn_m.js";
import { U as UIKitOverlay } from "./UIKitOverlay-C2yXBjdm.js";
import { useOverlayTrigger, useModalOverlay } from "@react-aria/overlays";
import { FocusScope } from "@react-aria/focus";
import { useOverlayTriggerState } from "@react-stately/overlays";
const SvgClose = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M7.516 5.63a1.333 1.333 0 1 0-1.885 1.886l8.485 8.486-8.485 8.485a1.333 1.333 0 1 0 1.886 1.886l8.485-8.485 8.485 8.485a1.333 1.333 0 0 0 1.886-1.886l-8.485-8.485 8.485-8.485a1.333 1.333 0 1 0-1.886-1.886l-8.485 8.485z",
        clipRule: "evenodd"
      }
    )
  }
);
const ModalTrigger = ({
  label,
  children,
  customTrigger,
  modalContentWrapperProps,
  ...props
}) => {
  const state = useOverlayTriggerState(props);
  const { triggerProps, overlayProps } = useOverlayTrigger(
    { type: "dialog" },
    state
  );
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    customTrigger ? React.cloneElement(customTrigger, {
      ...props,
      ...triggerProps,
      onClick: triggerProps.onPress
    }) : /* @__PURE__ */ jsx(
      Button,
      {
        ...props,
        ...triggerProps,
        onPress: (e) => {
          var _a, _b;
          (_a = props == null ? void 0 : props.onPress) == null ? void 0 : _a.call(props, e);
          (_b = triggerProps == null ? void 0 : triggerProps.onPress) == null ? void 0 : _b.call(triggerProps, e);
        },
        children: label
      }
    ),
    state.isOpen && /* @__PURE__ */ jsx(
      Modal,
      {
        ...props,
        state,
        contentWrapperProps: modalContentWrapperProps,
        children: React.cloneElement(
          children(() => state.close()),
          overlayProps
        )
      }
    )
  ] });
};
const DEFAULT_SPACING_PADDING = [52, 16, 16, 16];
const MD_DEFAULT_SPACING_PADDING = [36, 16, 16, 16];
const Modal = ({
  state,
  children,
  closeButtonSlot,
  overlayBackground = "background-transparent",
  overlayBlur = 4,
  md,
  contentWrapperProps,
  portalContainer,
  ...props
}) => {
  var _a, _b;
  const ref = useRef(null);
  const { modalProps, underlayProps } = useModalOverlay(props, state, ref);
  return /* @__PURE__ */ jsx(UIKitOverlay, { portalContainer, children: /* @__PURE__ */ jsx(FocusScope, { contain: true, autoFocus: true, children: /* @__PURE__ */ jsx(
    Flex,
    {
      ...underlayProps,
      style: { ...underlayProps.style },
      align: "center",
      justify: "center",
      bg: overlayBackground,
      backdropBlur: overlayBlur,
      position: {
        type: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 50
      },
      children: /* @__PURE__ */ jsxs(
        Box,
        {
          ...modalProps,
          style: { ...underlayProps.style },
          ref,
          position: { type: "relative" },
          width: "100%",
          height: "100dvh",
          p: (_a = props.p) != null ? _a : DEFAULT_SPACING_PADDING,
          md: { p: (_b = md == null ? void 0 : md.p) != null ? _b : MD_DEFAULT_SPACING_PADDING, ...md },
          className: "overflow-auto",
          ...props,
          children: [
            props.isDismissable && (closeButtonSlot ? closeButtonSlot == null ? void 0 : closeButtonSlot(() => state.close()) : /* @__PURE__ */ jsx(
              Button,
              {
                onPress: () => state.close(),
                autoFocus: true,
                variant: "transparent",
                border: { width: "0" },
                position: {
                  type: "absolute",
                  top: 14,
                  right: 16
                },
                md: { position: { top: 36, right: 40 } },
                children: /* @__PURE__ */ jsx(
                  SvgClose,
                  {
                    viewBox: "0 0 32 32",
                    className: "w-6 h-6 md:w-8 md:h-8"
                  }
                )
              }
            )),
            /* @__PURE__ */ jsx(
              Flex,
              {
                justify: "center",
                align: "center",
                height: "100%",
                ...contentWrapperProps,
                children
              }
            )
          ]
        }
      )
    }
  ) }) });
};
Modal.Trigger = ModalTrigger;
export {
  Modal as M,
  ModalTrigger as a
};
